import React, { useState, useContext, useEffect } from 'react';
import {
	TextField,
	Box,
	Button,
	Paper,
	Typography,
	MenuItem,
	InputLabel,
	Grid,
	FormControl,
	Select,
	InputAdornment,
	Autocomplete,
	Stack
} from '@mui/material';
import { isEmpty } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { getToken } from '../../api/Account';
import { DataContext } from '../../context/DataContext';
import { getRuta, simpleMessage } from '../../helpers/Helpers';
import { DIAS_ATENCION, requiereDiaAtencion } from '../../helpers/diaAtencion';
import { getClientsBySucursalAccessAsync } from '../../api/Clients';
import { useNavigate, useParams } from 'react-router-dom';
import { getPeriodicidadListAsync } from '../../api/Periodicidad';
import { getInteresListAsync } from '../../api/InteresCorriente';
import {
	getGestoresBySucursalAccessAsync,
	getPromotoresBySucursalAccessAsync
} from '../../api/Users';
import { getPlazoByPeriodicidadAsync } from '../../api/Plazo';
import { addCreditAsync } from '../../api/Credits';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment/moment';
import { getPromedioClientAsync } from '../../api/Report';
import MediumModal from '../../components/modals/MediumModal';
import AddFiador from './creditDetails/fiadorComponents/AddFiador';
import BackButton from '../../components/ui/BackButton';

const tituloPantallaSx = {
	fontFamily: "'Poppins', sans-serif",
	fontWeight: 600,
	fontSize: 16.5,
	color: 'text.primary',
	lineHeight: 1.1
};

// Titulo de cada tarjeta de seccion, igual que en Detalle de credito.
const tituloTarjetaSx = {
	fontFamily: "'Poppins', sans-serif",
	fontWeight: 600,
	fontSize: 16,
	color: 'text.primary',
	marginBottom: '18px'
};

const AddCredit = () => {
	const token = getToken();
	const { id } = useParams();
	let ruta = getRuta();
	let navigate = useNavigate();
	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	const [clientList, setClientList] = useState([]);

	const [selectedClient, setSelectedClient] = useState(null);

	const [periodicidadList, setPeriodicidadList] = useState([]);
	const [selectedPeriodicidad, setSelectedPeriodicidad] = useState('');

	const [diaAtencion, setDiaAtencion] = useState('');

	const [plazoList, setPlazoList] = useState([]);
	const [selectedPlazo, setSelectedPlazo] = useState('');

	const [interesCorrienteList, setInteresCorrienteList] = useState([]);
	const [selectedInteresCorriente, setSelectedInteresCorriente] = useState('');

	const [gestorList, setGestorList] = useState([]);
	const [selectedGestor, setSelectedGestor] = useState('');

	const [promotorList, setPromotorList] = useState([]);
	const [selectedPromotor, setSelectedPromotor] = useState('');

	const [montoPrincipal, setMontoPrincipal] = useState('');
	const [destino, setDestino] = useState('');

	const [fechaPrimeraCuota, setFechaPrimeraCuota] = useState(new Date());
	const [fechaSegundaCuota, setFechaSegundaCuota] = useState(new Date());
	const [promedio, setPromedio] = useState(0);
	const [tipoCredito, setTipoCredito] = useState(9);

	const [fiadorList, setFiadorList] = useState([]);
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getClientsBySucursalAccessAsync(token);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setClientList(result.data.result);

			if (id != 0) {
				let filtered = result.data.result.filter((item) => item.id == id);
				setSelectedClient(filtered[0]);
			}

			await getGestoresBySucursal();

			const resultPer = await getPeriodicidadListAsync(token);
			if (!resultPer.statusResponse) {
				setIsLoading(false);
				if (resultPer.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(resultPer.error, 'error');
				return;
			}
			setPeriodicidadList(resultPer.data.result);

			await getPromotores();

			const resultIC = await getInteresListAsync(token);
			if (!resultIC.statusResponse) {
				setIsLoading(false);
				if (resultIC.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(resultIC.error, 'error');
				return;
			}
			setInteresCorrienteList(resultIC.data.result);

			setIsLoading(false);
		})();
	}, []);

	//Devuelve un entero positivo
	const funtionSetMontoSolicitado = (value) => {
		if (/^[0-9]+$/.test(value.toString()) || value === '') {
			setMontoPrincipal(value);
			return;
		}
	};

	const defaultProps = {
		options: clientList,
		getOptionLabel: (option) => option.fullName
	};

	const periodicidadSeleccionada = periodicidadList.find(
		(item) => item.id === Number(selectedPeriodicidad)
	);
	const mostrarDiaAtencion = requiereDiaAtencion(periodicidadSeleccionada);

	const handleChangePeriodicidad = async (event) => {
		const selected = periodicidadList.filter((item) => item.id == event.target.value);

		// if (event.target.value === 2) {
		//   var date = new Date();
		//   setFechaPrimeraCuota(new Date(date.getFullYear(), date.getMonth(), 1));
		// } else {
		let dias = selected[0].cuotaDias;
		var newDate = new Date();
		newDate.setDate(newDate.getDate() + dias);
		setFechaSegundaCuota(newDate);
		// }
		setPlazoList([]);
		setSelectedPeriodicidad(event.target.value);
		// Si la nueva periodicidad es diaria el campo desaparece: limpiarlo evita
		// mandar un dia que el usuario ya no ve en pantalla.
		if (selected[0] && selected[0].cuotaDias <= 1) {
			setDiaAtencion('');
		}

		if (event.target.value !== '') {
			setIsLoading(true);
			const result = await getPlazoByPeriodicidadAsync(token, event.target.value);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setPlazoList(result.data.result);
			setIsLoading(false);
		} else {
			setPlazoList([]);
		}
	};

	const addNewCredit = async () => {
		if (validate()) {
			const data = {
				clientId: selectedClient.id,
				montoPrincipal: parseInt(montoPrincipal),
				fechaPrimeraCuota: moment(fechaPrimeraCuota).format('YYYY-MM-DD').toString(),
				fechaSegundaCuota: moment(fechaSegundaCuota).format('YYYY-MM-DD').toString(),
				destino: destino.trim(),
				periocidadId: selectedPeriodicidad,
				diaAtencion: mostrarDiaAtencion ? diaAtencion : null,
				plazoId: selectedPlazo,
				interesCorrienteId: selectedInteresCorriente,
				gestor: selectedGestor,
				promotor: selectedPromotor === '' ? selectedGestor : selectedPromotor,
				tipoCredito,
				fiadorList
			};

			setIsLoading(true);
			const result = await addCreditAsync(token, data);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setIsLoading(false);
			clearData();
			simpleMessage('Crédito Agregado...!', 'success');
		}
	};

	//Validando campos ingresados
	const validate = () => {
		let isValid = true;
		if (isEmpty(selectedClient)) {
			simpleMessage('Debe seleccionar un cliente', 'error');
			return (isValid = false);
		}

		if (montoPrincipal === '') {
			simpleMessage('Debe ingresar un monto', 'error');
			return (isValid = false);
		}

		if (fechaPrimeraCuota === '') {
			simpleMessage('Debe ingresar una fecha', 'error');
			return (isValid = false);
		}

		if (selectedGestor === '') {
			simpleMessage('Debe seleccionar un gestor', 'error');
			return (isValid = false);
		}

		if (selectedPlazo === '') {
			simpleMessage('Debe seleccionar un plazo', 'error');
			return (isValid = false);
		}

		if (selectedInteresCorriente === '') {
			simpleMessage('Debe seleccionar una tasa de interes', 'error');
			return (isValid = false);
		}

		if (isEmpty(destino)) {
			simpleMessage('Debe seleccionar un destino de credito', 'error');
			return (isValid = false);
		}

		if (mostrarDiaAtencion && isEmpty(diaAtencion)) {
			simpleMessage('Debe seleccionar un dia de atencion', 'error');
			return (isValid = false);
		}

		if (selectedPeriodicidad === 2 && moment(fechaSegundaCuota).isBefore(fechaPrimeraCuota)) {
			simpleMessage(
				'La fecha de la primera cuota no puede ser antes que la segunda cuota',
				'error'
			);
			return (isValid = false);
		}
		return isValid;
	};

	const clearData = () => {
		setSelectedClient(null);
		setMontoPrincipal('');
		setSelectedGestor('');
		setDestino('');
		setSelectedPeriodicidad('');
		setSelectedPlazo('');
		setSelectedInteresCorriente('');
		setFiadorList([]);
	};

	const getPromotores = async () => {
		const result = await getPromotoresBySucursalAccessAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setPromotorList(result.data.result);
	};

	const getPromedioCLient = async (id) => {
		setIsLoading(true);
		const result = await getPromedioClientAsync(token, id);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setPromedio(result.data.result.toFixed(2));
		setIsLoading(false);
	};

	const getGestoresBySucursal = async () => {
		const result = await getGestoresBySucursalAccessAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setGestorList(result.data.result);
	};

	return (
		<div>
			{/* Sin Container: el layout del shell ya define ancho y padding. */}
			<Stack spacing={2.5}>
				<Paper sx={{ padding: '18px 22px' }}>
					<Stack direction="row" alignItems="center" spacing={2}>
						<BackButton onClick={() => navigate(`${ruta}/credits`)} />
						<Box sx={{ minWidth: 0 }}>
							<Typography sx={tituloPantallaSx}>Agregar crédito</Typography>
							<Typography
								sx={{ fontSize: 13, color: 'text.disabled', marginTop: '3px' }}
							>
								Registrar un nuevo crédito
							</Typography>
						</Box>
					</Stack>
				</Paper>

				<Stack spacing={2.5}>
					<Paper sx={{ padding: '22px' }}>
						<Stack
							direction={{ xs: 'column', sm: 'row' }}
							justifyContent="space-between"
							alignItems={{ xs: 'stretch', sm: 'center' }}
							spacing={2}
							sx={{ marginBottom: '18px' }}
						>
							<Typography sx={{ ...tituloTarjetaSx, marginBottom: 0 }}>
								Datos del Crédito
							</Typography>

							<Button
								onClick={() => {
									setShowModal(true);
								}}
								variant="outlined"
								color="warning"
								startIcon={<FontAwesomeIcon icon={faCirclePlus} />}
								sx={{ whiteSpace: 'nowrap' }}
							>
								Fiador
							</Button>
						</Stack>

						{selectedClient ? (
							<Paper
								style={{
									padding: 20
								}}
							>
								<Stack
									spacing={1}
									direction={{ xs: 'column', sm: 'row' }}
									justifyContent="space-between"
								>
									<Stack spacing={1} direction="row">
										<Typography
											color={'#c77f12'}
											style={{ textAlign: 'left' }}
										>
											Id Cliente:
										</Typography>

										<Typography style={{ textAlign: 'left' }}>
											{selectedClient.id}
										</Typography>
									</Stack>

									<Stack spacing={1} direction="row">
										<Typography
											color={'#c77f12'}
											style={{ textAlign: 'left' }}
										>
											Cédula:
										</Typography>
										<Typography style={{ textAlign: 'left' }}>
											{selectedClient.identification}
										</Typography>
									</Stack>

									<Stack spacing={1} direction="row">
										<Typography
											color={'#c77f12'}
											style={{ textAlign: 'left' }}
										>
											Teléfono:
										</Typography>
										<Typography style={{ textAlign: 'left' }}>
											{selectedClient.phone}
										</Typography>
									</Stack>

									<Stack spacing={1} direction="row">
										<Typography
											color={'#c77f12'}
											style={{ textAlign: 'left' }}
										>
											Promedio:
										</Typography>
										<Typography style={{ textAlign: 'left' }}>
											{promedio}
										</Typography>
									</Stack>
								</Stack>
							</Paper>
						) : (
							<></>
						)}

						<Grid container spacing={2} marginTop={1}>
							<Grid item xs={12} sm={6}>
								<Stack spacing={2}>
									<Autocomplete
										{...defaultProps}
										id="combo-box-demo"
										value={selectedClient}
										onChange={(event, newValue) => {
											setSelectedClient(newValue);
											if (newValue) {
												getPromedioCLient(newValue.id);
											}
										}}
										noOptionsText="No existe cliente con ese nombre"
										renderInput={(params) => (
											<TextField
												fullWidth
												{...params}
												label="Seleccione un Cliente"
											/>
										)}
									/>

									<FormControl fullWidth style={{ textAlign: 'left' }}>
										<InputLabel id="demo-simple-select-standard-label">
											Lista de Fiadores
										</InputLabel>
										<Select
											labelId="demo-simple-select-standard-label"
											id="demo-simple-select-standard"
											label="Lista de Fiadores"
											style={{ textAlign: 'left' }}
										>
											<MenuItem value="">
												<em>Lista de Fiadores</em>
											</MenuItem>
											{fiadorList.map((item) => {
												return (
													<MenuItem
														key={fiadorList.indexOf(item) + 1}
													>
														{item.fullName}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>

									<TextField
										required
										fullWidth
										onChange={(e) =>
											funtionSetMontoSolicitado(e.target.value)
										}
										value={montoPrincipal}
										label={'Monto Solicitado'}
										InputProps={{
											startAdornment: (
												<InputAdornment position="start">
													C$
												</InputAdornment>
											)
										}}
									/>

									<FormControl fullWidth style={{ textAlign: 'left' }}>
										<InputLabel id="demo-simple-select-standard-label">
											Gestor
										</InputLabel>
										<Select
											labelId="demo-simple-select-standard-label"
											id="demo-simple-select-standard"
											onChange={(e) => setSelectedGestor(e.target.value)}
											value={selectedGestor}
											label="Gestor"
											style={{ textAlign: 'left' }}
										>
											<MenuItem value="">
												<em>Seleccione un gestor</em>
											</MenuItem>
											{gestorList.map((item) => {
												return (
													<MenuItem key={item.id} value={item.id}>
														{item.fullName}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>

									<FormControl fullWidth style={{ textAlign: 'left' }}>
										<InputLabel id="demo-simple-select-standard-label">
											Promotor
										</InputLabel>
										<Select
											labelId="demo-simple-select-standard-label"
											id="demo-simple-select-standard"
											onChange={(e) =>
												setSelectedPromotor(e.target.value)
											}
											value={selectedPromotor}
											label="Promotor"
											style={{ textAlign: 'left' }}
										>
											<MenuItem value="">
												<em>Seleccione un promotor</em>
											</MenuItem>
											{promotorList.map((item) => {
												return (
													<MenuItem key={item.id} value={item.id}>
														{item.fullName}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>

									<TextField
										required
										fullWidth
										onChange={(e) =>
											setDestino(e.target.value.toUpperCase())
										}
										value={destino}
										label={'Destino'}
									/>
								</Stack>
							</Grid>

							<Grid item xs={12} sm={6}>
								<Stack spacing={2}>
									<FormControl fullWidth style={{ textAlign: 'left' }}>
										<InputLabel id="demo-simple-select-standard-label">
											Periodicidad
										</InputLabel>
										<Select
											labelId="demo-simple-select-standard-label"
											id="demo-simple-select-standard"
											onChange={handleChangePeriodicidad}
											value={selectedPeriodicidad}
											label="Periodicidad"
											style={{ textAlign: 'left' }}
										>
											<MenuItem value="">
												<em>Seleccione un Periodo</em>
											</MenuItem>
											{periodicidadList.map((item) => {
												return (
													<MenuItem key={item.id} value={item.id}>
														{item.description}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>

									{mostrarDiaAtencion ? (
										<FormControl fullWidth style={{ textAlign: 'left' }}>
											<InputLabel id="select-dia-atencion-label">
												Dia de Atencion
											</InputLabel>
											<Select
												labelId="select-dia-atencion-label"
												onChange={(e) => setDiaAtencion(e.target.value)}
												value={diaAtencion}
												label="Dia de Atencion"
												style={{ textAlign: 'left' }}
											>
												<MenuItem value="">
													<em>Seleccione un Dia</em>
												</MenuItem>
												{DIAS_ATENCION.map((dia) => (
													<MenuItem key={dia} value={dia}>
														{dia}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									) : null}

									<FormControl fullWidth style={{ textAlign: 'left' }}>
										<InputLabel id="demo-simple-select-standard-label">
											Plazo
										</InputLabel>
										<Select
											labelId="demo-simple-select-standard-label"
											id="demo-simple-select-standard"
											onChange={(e) => setSelectedPlazo(e.target.value)}
											value={selectedPlazo}
											label="Plazo"
											style={{ textAlign: 'left' }}
										>
											<MenuItem value="">
												<em>Seleccione un Plazo</em>
											</MenuItem>
											{plazoList.map((item) => {
												return (
													<MenuItem key={item.id} value={item.id}>
														{item.description}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>

									<FormControl fullWidth style={{ textAlign: 'left' }}>
										<InputLabel id="demo-simple-select-standard-label">
											Tasa de interes
										</InputLabel>
										<Select
											labelId="demo-simple-select-standard-label"
											id="demo-simple-select-standard"
											onChange={(e) =>
												setSelectedInteresCorriente(e.target.value)
											}
											value={selectedInteresCorriente}
											label="Tasa de interes"
											style={{ textAlign: 'left' }}
										>
											<MenuItem value="">
												<em>Seleccione una Tasa de Interes</em>
											</MenuItem>
											{interesCorrienteList.map((item) => {
												return (
													<MenuItem key={item.id} value={item.id}>
														{`${item.intCorriente.toFixed(2)} %`}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>

									<Stack spacing={2} direction="row">
										<DesktopDatePicker
											closeOnSelect
											label="Fecha Primera Cuota"
											inputFormat="DD/MM/YYYY"
											value={fechaPrimeraCuota}
											onChange={(newValue) =>
												setFechaPrimeraCuota(newValue)
											}
											renderInput={(params) => (
												<TextField fullWidth {...params} />
											)}
										/>

										{selectedPeriodicidad === 2 ? (
											<DesktopDatePicker
												closeOnSelect
												label="Fecha Segunda Cuota"
												inputFormat="DD/MM/YYYY"
												value={fechaSegundaCuota}
												onChange={(newValue) =>
													setFechaSegundaCuota(newValue)
												}
												renderInput={(params) => (
													<TextField fullWidth {...params} />
												)}
											/>
										) : (
											<></>
										)}
									</Stack>

									<FormControl
										fullWidth
										style={{ textAlign: 'left', marginTop: 20 }}
									>
										<InputLabel id="demo-simple-select-standard-label">
											Tipo de Credito
										</InputLabel>
										<Select
											labelId="demo-simple-select-standard-label"
											id="demo-simple-select-standard"
											onChange={(e) => setTipoCredito(e.target.value)}
											value={tipoCredito}
											label="Tipo de Credito"
										>
											<MenuItem value={9}>PERSONAL</MenuItem>
											<MenuItem value={19}>MICRO CREDITO</MenuItem>
										</Select>
									</FormControl>

									<Button
										variant="contained"
										color="primary"
										startIcon={<FontAwesomeIcon icon={faSave} />}
										onClick={() => addNewCredit()}
										sx={{ height: 46, alignSelf: 'flex-start', paddingX: 2.5 }}
									>
										Agregar crédito
									</Button>
								</Stack>
							</Grid>

							{/* <Grid item xs={12}></Grid> */}
						</Grid>
					</Paper>
				</Stack>
			</Stack>

			<MediumModal titulo={'Agregar Fiador'} isVisible={showModal} setVisible={setShowModal}>
				<AddFiador
					setShowModal={setShowModal}
					fiadorList={fiadorList}
					setFiadorList={setFiadorList}
				/>
			</MediumModal>
		</div>
	);
};

export default AddCredit;
